import { defineStore } from 'pinia';
export const usePackagePopupStore = defineStore('package-popup', {
    state: () => ({
        visible: false,
        popupUrl: '',
        openVersion: 0,
        handoffPending: false,
    }),
    actions: {
        startHandoff() {
            this.handoffPending = true;
        },
        finishHandoff() {
            this.handoffPending = false;
        },
        openByUrl(url) {
            if (!url)
                return;
            this.popupUrl = url;
            this.visible = true;
            this.openVersion += 1;
        },
        close() {
            this.visible = false;
        },
    },
});
